import { Theme } from "../../../components/constants";

export default {
    mainContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: '40px'
    },
    filtersRow: {
        display: 'flex', 
        gap: '20px'
    },
    actionRow: {
        display: 'flex', 
        gap: '20px', 
        justifyContent: 'space-between'
    },
    actionsRowLeftColumn: {
        display: 'flex', 
        gap: '20px', 
        alignItems: 'center'
    },
    text: {
		fontSize: "16px",
		color: Theme.TEXT_PRIMARY_BLACK,
		whiteSpace: 'pre'
	},
    actionButton: {
        width: '50%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '10px 20px'
    }
}